<template>
  <div class="container container-network container-management-panel font">
    <div class="title">{{ $t("managePanel.title") }}</div>
    <div class="title">{{ getUserName || "משתמש לא מחובר" }}</div>
    <div v-if="getUserName == ''" style="padding-top: 10px">
      <div class="btn" @click="backToMainPage">
        {{ $t("general.backToMainPage") }}
      </div>
    </div>
    <div class="error">{{ errorMsgReport }}</div>
    <div v-if="getUserName != '' && !managerConnected">
      <div class="footer flex" style="justify-content: center">
        <div style="display: flex; flex-direction: column">
          <div class="error">{{ errorMsg }}</div>
          <div>
            <div>
              <label for="newpsw">{{ $t("general.enterPassword") }}</label>
              <input
                v-model="password"
                type="password"
                @keydown.enter="loginManager"
                @input="errorMsg = ''"
                v-focus
              />
            </div>
          </div>
          <div style="padding-top: 10px">
            <div class="btn" @click="loginManager">
              {{ $t("general.confirm") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex" v-if="managerConnected">
      <div>
        <div class="card">
          <div class="title-list">אוצר החכמה</div>
          <template
            v-if="appsInPermissions == 'both' || appsInPermissions == 'otzar'"
          >
            <div class="flex" style="padding-top: 10px">
              <div class="stations-msg">
                {{ $t("managePanel.maxStations") }} {{ max }} ({{
                  $t("managePanel.stationsInUse")
                }}
                {{ activeUsers }})
              </div>
              <div
                style="padding-right: 10px"
                class="btn"
                @click="getActiveUsersInfo"
              >
                {{ $t("mainTools.refresh") }}
              </div>
            </div>
            <div style="padding-right: 10px" class="flex">
              <input
                id="o_pdf"
                style="height: 20px"
                type="radio"
                value="pdf"
                name="format"
                checked
                @input="setPDF"
              />
              <label
                for="o_pdf"
                style="height: 30px; line-height: 30px; font-size: 16px"
                >PDF</label
              >
              <input
                id="oxls"
                style="height: 20px"
                type="radio"
                value="xls"
                name="format"
                @input="setXLS"
              />
              <label
                for="oxls"
                style="height: 30px; line-height: 30px; font-size: 16px"
                >EXCEL</label
              >
            </div>
            <div class="flex" style="justify-content: center; padding: 10px">
              <div>
                <div
                  style="margin-top: 5px; display: flex; flex-direction: column"
                >
                  <div>
                    <span
                      style="
                        justify-content: space-between;
                        display: flex;
                        padding-bottom: 5px;
                      "
                      class="ml-1"
                    >
                      {{ $t("managePanel.fromDate") }}</span
                    >
                    <input class="form-control" type="date" id="FDateOtzar" />
                  </div>
                  <div>
                    <span
                      style="justify-content: space-between; display: flex"
                      class="ml-1"
                    >
                      {{ $t("managePanel.toDate") }}</span
                    >
                    <input class="form-control" type="date" id="TDateOtzar" />
                  </div>
                </div>
                <div
                  style="
                    padding-top: 15px;
                    display: flex;
                    justify-content: center;
                  "
                >
                  <div class="btn" @click="generateReport(1, 'Otzar')">
                    {{ $t("managePanel.generateUsageReport") }}
                  </div>
                  <div class="btn" @click="generateReport(0, 'Otzar')">
                    {{ $t("managePanel.generateFailReport") }}
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="stations-msg" v-else>
            {{ $t("login.noValidLicense") }}
          </div>
        </div>
        <div class="card">
          <div class="title-list">מפרשי האוצר</div>
          <template
            v-if="appsInPermissions == 'both' || appsInPermissions == 'mef'"
          >
            <div class="flex" style="padding-top: 10px">
              <div class="stations-msg">
                {{ $t("managePanel.maxStations") }} {{ maxMef }} ({{
                  $t("managePanel.stationsInUse")
                }}
                {{ activeUsersMef }})
              </div>
              <div
                style="padding-right: 10px"
                class="btn"
                @click="getActiveUsersInfo"
              >
                {{ $t("mainTools.refresh") }}
              </div>
            </div>
            <div style="padding-right: 10px" class="flex">
              <input
                id="r_pdf"
                style="height: 20px"
                type="radio"
                value="pdf"
                name="format"
                checked
                @input="setPDF"
              />
              <label
                for="r_pdf"
                style="height: 30px; line-height: 30px; font-size: 16px"
                >PDF</label
              >
              <input
                id="rxls"
                style="height: 20px"
                type="radio"
                value="xls"
                name="format"
                @input="setXLS"
              />
              <label
                for="rxls"
                style="height: 30px; line-height: 30px; font-size: 16px"
                >EXCEL</label
              >
            </div>
            <div class="flex" style="justify-content: center; padding: 10px">
              <div>
                <div
                  style="margin-top: 5px; display: flex; flex-direction: column"
                >
                  <div>
                    <span
                      style="
                        justify-content: space-between;
                        display: flex;
                        padding-bottom: 5px;
                      "
                      class="ml-1"
                    >
                      {{ $t("managePanel.fromDate") }}</span
                    >
                    <input class="form-control" type="date" id="FDateMef" />
                  </div>
                  <div>
                    <span
                      style="justify-content: space-between; display: flex"
                      class="ml-1"
                    >
                      {{ $t("managePanel.toDate") }}</span
                    >
                    <input class="form-control" type="date" id="TDateMef" />
                  </div>
                </div>
                <div
                  style="
                    padding-top: 15px;
                    display: flex;
                    justify-content: center;
                  "
                >
                  <div class="btn" @click="generateReport(1, 'Mef')">
                    {{ $t("managePanel.generateUsageReport") }}
                  </div>
                  <div class="btn" @click="generateReport(0, 'Mef')">
                    {{ $t("managePanel.generateFailReport") }}
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="stations-msg" v-else>
            {{ $t("login.noValidLicense") }}
          </div>
        </div>
      </div>

      <div>
        <div class="card">
          <div class="title-list">
            {{ $t("myProfile.disconnectSettings") }}
          </div>
          <div class="flex" style="justify-content: center; padding: 10px">
            <div style="display: flex; flex-direction: column">
              <div>
                <div>
                  <label for="disconnectMinutes">{{
                    $t("managePanel.disconnectMinutesTitle")
                  }}</label>
                  <input
                    id="disconnectMinutes"
                    :value="disconnectMinutes"
                    type="text"
                  />
                </div>
              </div>
              <div style="padding-top: 10px">
                <div class="btn" @click="setDisconnectMinutes">
                  {{ $t("general.saveChanges") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="title-list">
            {{ $t("managePanel.passwordChange") }}
          </div>
          <div class="flex" style="justify-content: center; padding: 10px">
            <div style="display: flex; flex-direction: column">
              <div>
                <div>
                  <label for="oldpsw">{{ $t("general.old_password") }}</label>
                  <input id="oldpsw" v-model="oldp" type="password" />
                </div>
                <div>
                  <label for="newpsw">{{ $t("general.new_password") }}</label>
                  <input id="newpsw" v-model="newp" type="password" />
                </div>
              </div>
              <div style="padding-top: 10px">
                <div class="btn" @click="setNewPsw">
                  {{ $t("general.confirm") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding-top: 10px">
      <div class="btn" @click="backToMainPage">
        {{ $t("general.backToMainPage") }}
      </div>
    </div>
    <div v-if="loading" class="loader-container">
      <bounce-loader
        :loading="loading"
        :color="color"
        :size="size"
      ></bounce-loader>
      <span class="loader-msg">{{ $t("managePanel.generatingReport") }}</span>
    </div>
  </div>
</template>

<script>
import { Axios } from "@/services/_axios";
import { mapGetters } from "vuex";
import { loginIPUserManager } from "@/services/login";
import { printPreview } from "@/services/bookLists.js";
import BounceLoader from "vue-spinner/src/BounceLoader.vue";
import { updateUserExtraInfo } from "@/services/login";
import onlineHelper from "@/services/onlineStations";
import writeXlsxFile from "write-excel-file";
import moment from "moment";

let date1 = new Date();
let today = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
import { permissionsEnum } from "@/services/license.js";
export default {
  data() {
    return {
      password: "",
      oldp: "",
      newp: "",
      max: 0,
      activeUsers: 0,
      maxMef: 0,
      activeUsersMef: 0,
      fromDate: today,
      toDate: today,
      fromDateMef: today,
      toDateMef: today,
      loading: false,
      color: "var(--custom-color1)",
      size: "50px",
      errorMsg: "",
      errorMsgReport: "",
      reportFormat: "PDF",
    };
  },
  components: {
    BounceLoader,
  },
  computed: {
    ...mapGetters("user", ["getUserName"]),
    managerConnected() {
      return this.$store.state.user.IPUserManager;
    },
    disconnectMinutes() {
      return this.$store.state.user.extraInfo?.idleminutes || 20;
    },
    appsInPermissions() {
      let otzar =
        this.$store.state.user.permissions & permissionsEnum.GENERAL.value ||
        this.$store.state.user.permissions & permissionsEnum.SCHOOL.value;
      let mef =
        this.$store.state.user.permissions & permissionsEnum.MEF_OTZAR.value;

      return otzar && mef ? "both" : otzar ? "otzar" : "mef";
    },
  },
  methods: {
    setPDF() {
      this.reportFormat = "PDF";
    },
    setXLS() {
      this.reportFormat = "XLS";
    },
    async setDisconnectMinutes() {
      if (this.$store.state.user.extraInfo) {
        try {
          this.$store.state.user.extraInfo.idleminutes = parseInt(
            document.getElementById("disconnectMinutes").value
          );
          if (await updateUserExtraInfo(this.$store.state.user.extraInfo)) {
            //set extra info in state

            //set onlineTimer
            onlineHelper.startOnlineTimer();
          } else {
            alert("error" + ex.message);
          }
          this.dirty = false;
        } catch (ex) {
          console.log(ex);
        }
      }
    },
    async generateReport(success, app) {
      this.errorMsgReport = "";
      this.loading = true;
      let fromDate = document.getElementById("FDate" + app).value;
      let toDate = document.getElementById("TDate" + app).value;
      if (!fromDate || !toDate) {
        this.errorMsgReport = this.$t("managePanel.chooseDates");
        this.loading = false;
        return;
      }

      let data = await Axios.get(
        `/api/user/visits/${fromDate}/${toDate}/${success}/${this.$t(
          "general.langCode"
        )}/${app}/${this.reportFormat}`
      );
      this.loading = false;
      if (!data.data) {
        this.$notify({
          type: "error",
          message: this.$t("managePanel.noPermission"),
          timeout: 5000,
        });
        return;
      }
      let fileNmae =
        (app == "Otzar" ? this.$t("general.title") : this.$t("general.mef")) +
        "_" +
        (success
          ? this.$t("managePanel.usageReport")
          : this.$t("managePanel.failReport")) +
        "_" +
        fromDate.replace("/", "") +
        "_" +
        toDate.replace("/", "");

      if (this.reportFormat != "PDF") createExcel(data.data, fileNmae);
      else printPreview(data.data, fileNmae);
    },
    backToMainPage() {
      this.$router.push("/");
    },
    async loginManager() {
      let login = await loginIPUserManager(this.password);
      if (login.login) {
        if (login.weakPass) confirm(this.$t("managePanel.recommendChangePass"));
        this.$store.state.user.IPUserManager = true;
        this.getActiveUsersInfo();
        this.$nextTick(() => {
          //set date fields
          let date1 = new Date();
          document.getElementById("TDateOtzar").valueAsDate = new Date(
            Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())
          );
          document.getElementById("FDateOtzar").valueAsDate = new Date(
            Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())
          );
          document.getElementById("TDateMef").valueAsDate = new Date(
            Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())
          );
          document.getElementById("FDateMef").valueAsDate = new Date(
            Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())
          );
        });
      } else this.errorMsg = this.$t("general.errorPassword");
    },
    async setNewPsw() {
      if (!this.oldp || !this.newp) {
        return;
      }
      let ret = await Axios.post("/api/user/changePassword", {
        oldPassword: this.oldp,
        newPassword: this.newp,
      });
      this.oldp = "";
      this.newp = "";
      let oldPswCorrect = true;

      if (ret.data == "NO_USER") {
        oldPswCorrect = false;
      }

      //check for old psw
      if (!oldPswCorrect) {
        this.$notify({
          type: "error",
          message: this.$t("general.wrong_psw"),
          timeout: 2000,
        });
        return;
      }
      let changed = false;
      if (ret.data == "SUCCESS") {
        changed = true;
      }

      //set new psw
      if (changed) {
        this.$notify({
          type: "success",
          message: this.$t("general.success_action"),
          timeout: 2000,
        });
      } else {
        this.$notify({
          type: "error",
          message: this.$t("general.error_action"),
          timeout: 2000,
        });
      }
    },
    async getActiveUsersInfo() {
      let managerData = await Axios.get("/api/user/IPUser/activeUsers");
      if (managerData) managerData = managerData.data;
      this.max = managerData.stations;
      this.activeUsers = managerData.activeStations;
      this.maxMef = managerData.mefStations;
      this.activeUsersMef = managerData.mefActiveStations;
    },
  },
  async mounted() {
    try {
      if (this.managerConnected) {
        this.getActiveUsersInfo();
      }
      /*       this.max = managerData.userData.stations;
      this.activeUsers = managerData.activeUsers; */
      //set date fields
      if (document.getElementById("TDateOtzar")) {
        let date1 = new Date();
        document.getElementById("TDateOtzar").valueAsDate = new Date(
          Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())
        );
        document.getElementById("FDateOtzar").valueAsDate = new Date(
          Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())
        );
        document.getElementById("TDateMef").valueAsDate = new Date(
          Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())
        );
        document.getElementById("FDateMef").valueAsDate = new Date(
          Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())
        );
      }
    } catch (ex) {
      console.error(ex);
    }
  },
};

async function createExcel(info, fileName) {
  console.log(info);
  let total = 0;
  let totalTime = 0;
  let dailyTotal = 0;
  let final = [
    [
      {
        value: info.title1,
        fontWeight: "bold",
        align: "center",
        alignVertical: "center",
        span: 3,
        backgroundColor: "#CCD1D1",
        bordercolor: "#5D6D7E",
      },
    ],

    [
      {
        value: info.title2,
        align: "center",
        alignVertical: "center",
        span: 3,
      },
    ],

    [
      {
        value: info.title3,
        align: "center",
        alignVertical: "center",
        span: 3,
      },
    ],
  ];
  Object.keys(info.data).forEach((k) => {
    dailyTotal = 0;
    final.push([
      {
        value: k,
        align: "right",
        alignVertical: "center",
        span: 3,
        backgroundColor: "#85929E",
        bordercolor: "#5D6D7E",
      },
    ]);
    final.push([
      {
        value: "שעת כניסה",
        align: "right",
        alignVertical: "center",
        backgroundColor: "#CCD1D1",
        bordercolor: "#5D6D7E",
      },
      {
        value: "שעת יציאה",
        align: "right",
        alignVertical: "center",
        backgroundColor: "#CCD1D1",
        bordercolor: "#5D6D7E",
      },
      {
        value: "זמן בדקות",
        align: "right",
        alignVertical: "center",
        backgroundColor: "#CCD1D1",
        bordercolor: "#5D6D7E",
      },
      {
        value: "כתובת IP",
        align: "right",
        alignVertical: "center",
        backgroundColor: "#CCD1D1",
        bordercolor: "#5D6D7E",
      },
    ]);

    info.data[k].forEach((v) => {
      totalTime += v.total;
      dailyTotal += v.total;
      final.push([
        {
          value: getTimePart(v.startVisit),
          align: "right",
          alignVertical: "center",
        },
        {
          value: getTimePart(v.endVisit),
          align: "right",
          alignVertical: "center",
        },
        {
          value: v.total,
          align: "right",
          alignVertical: "center",
        },
        {
          value: v.ip,
          align: "right",
          alignVertical: "center",
        },
      ]);
    });
    final.push([
      {
        value: "סך כניסות: " + info.data[k].length,
        align: "right",
        alignVertical: "center",
        span: 3,
      },
    ]);
    final.push([
      {
        value: "סך זמן בדקות: " + Math.floor(dailyTotal),
        align: "right",
        alignVertical: "center",
        span: 3,
      },
    ]);
    total += info.data[k].length;
  });
  final.push([
    {
      value: "סך כניסות כולל: " + total,
      align: "right",
      alignVertical: "center",
      span: 3,
    },
  ]);

  final.push([
    {
      value: "סך זמן בדקות: " + Math.floor(totalTime),
      align: "right",
      alignVertical: "center",
      span: 3,
    },
  ]);

  await writeXlsxFile(final, {
    fileName: fileName + ".xlsx",
  });
}

function getTimePart(d) {
  if (d == "0000-00-00 00:00:00") return false;
  return new moment(d).format("HH:mm");
}
</script>

<style lang="scss" scoped>
.stations-msg {
  font-weight: 500;
  font-size: 15px;
  padding-left: 10px;
  padding-right: 10px;
}
.error {
  color: red;
  font-size: 18px;
  padding-top: 10px;
  font-weight: 500;
}
.loader-container {
  margin: auto;
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  background-color: lightgray;
  position: absolute;
  top: 200px;
  left: 40%;
  text-align: center;
  opacity: 95%;
  color: black;
  padding-top: 50px;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  margin: 20px 30px;
  -webkit-box-shadow: 1px 2px 7px #00000026;
  box-shadow: 1px 2px 7px #00000026;
  font-size: 18px;
}
.loader-msg {
  color: black;
  opacity: 100%;
  padding-top: 15px;
}
.container-network {
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;
  // height: 100%;
  // width: 100%;
  margin-top: 90px;
  max-width: 800px;
  margin: 90px auto 10px;
  .footer {
    justify-content: space-between;
    display: flex;
    padding: 15px 20px;
    margin-top: 40px;
    font-weight: bold;
  }
}
.mef-net-btn {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
}
.item-comp-net {
  padding: 10px 20px;
  min-height: 47px;
  height: auto;
  border-bottom: 1px solid rgba(158, 158, 158, 0.267);
  align-items: center;
  display: flex;
  .btn {
    margin-right: auto;
  }
  &:hover {
    background-color: rgb(242, 241, 241);
    // cursor: pointer;
  }
}
.header-content {
  padding: 0 20px;
  font-size: 12px;
  font-weight: bold;
  border-bottom: 1px solid rgba(184, 184, 184, 0.267);
  display: flex;
  color: rgb(177, 177, 177);
  & > div {
    flex-grow: 1;
  }
}
.name {
  max-width: 150px;
  width: 150px;
}
.time {
  color: rgb(177, 177, 177);
  padding-right: 15px;
}
.title {
  font-size: 16px;
  color: var(--custom-color1);
  //    width: 700px;
  margin: 0 auto;
}
.card {
  border: 1px solid #e8e8e8;
  border-radius: 5px;

  margin: 20px 30px;
  box-shadow: 1px 2px 7px #00000026;
  .title-list {
    background-color: #f5f5f5;
    padding: 0 20px;
    height: 47px;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    border-bottom: 1.5px solid #e8e8e8;
  }
}
.lang {
  color: var(--custom-color1);
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
}
.en {
  direction: ltr;
  text-align: left;
}
</style>
